import React, { useEffect, useRef, useState } from "react";
import { socket } from "./socket";
import "./App.css";

//const MAX_SPEED = 25;
const BASE_MAX_SPEED = 25; // fixed physical max

const imgOn = "/images/giglo_remote_status_light_on.png";
const imgOff = "/images/giglo_remote_status_light_off.png";

export default function App() {
 const [speed, setSpeed] = useState(0);
const [maxSpeed, setMaxSpeed] = useState(BASE_MAX_SPEED);
const maxSpeedRef = useRef(BASE_MAX_SPEED);
const speedLimitPercent = Math.round(
  (maxSpeed / BASE_MAX_SPEED) * 100
);

const currentPercent = Math.round(
  (speed / BASE_MAX_SPEED) * 100
);	
	
const isHoldingRef = useRef(false);	
const speedRef = useRef(0);	
const lastSeqRef = useRef(0);
const isUserInteractingRef = useRef(false);
const debounceRef = useRef(null);	
  const intervalRef = useRef(null);
  const lastSendRef = useRef(0);
  const isStoppedRef = useRef(true); // 🔒 START LOCK
const isMobileConnectedRef = useRef(false); // 🔥 NEW
  const [pressed, setPressed] = useState({
    up: false,
    down: false,
    stop: false,
  });

 
  const [signal, setSignal] = useState(false);
  const [username, setUsername] = useState("");
	
   const [isMobileConnected, setIsMobileConnected] = useState(false);	

  /* ---------------- USERNAME ---------------- */
  useEffect(() => {
    const id = window.location.pathname.split("/").pop();
    setUsername(id);
  }, []);

  /* ---------------- SOCKET ---------------- */
  useEffect(() => {
    if (!username) return;

    if (!socket.connected) {
      socket.connect();
    }

    console.log("🔌 Connecting socket...");

    socket.off("receive_message"); // ✅ FIX duplicate

    socket.on("connect", () => {
      console.log("✅ Web Connected");
		
		 socket.emit("send_message", {
    uname: username,
    machinename: "Tremblr",
    massage: "WEB_READY",
  });
		
    });

socket.on("receive_message", (msg) => {
  if (msg.machinename !== "Tremblr") return;
  if (msg.uname !== username) return;

  /* ✅ ORDERING */
  if (msg.seq && msg.seq <= lastSeqRef.current) return;
  lastSeqRef.current = msg.seq || lastSeqRef.current;

  console.log("📡 WEB RECEIVED:", msg);

  /* MOBILE CONNECT */
  if (msg.massage === "MOBILE_CONNECTED") {
    isMobileConnectedRef.current = true;
    setIsMobileConnected(true);
    return;
  }

  /* MOBILE DISCONNECT */
  if (msg.massage === "MOBILE_DISCONNECTED") {
    isMobileConnectedRef.current = false;
    setIsMobileConnected(false);

    isStoppedRef.current = true;
    setSpeed(0);

    clearInterval(intervalRef.current);
    intervalRef.current = null;

    setSignal(false);
    return;
  }
	
	
/* 🔥 MAX SPEED FROM MOBILE */
if (msg.massage === "SET_MAX_SPEED") {
  const newMax = Math.max(1, msg.value || 1);

  maxSpeedRef.current = newMax;
  setMaxSpeed(newMax);

  // clamp current speed
  if (speedRef.current > newMax) {
    speedRef.current = newMax;
    setSpeed(newMax);
	  
	emitUpdate(newMax);  
  }

  return;
}	

  /* 🔥 SYNC (SOURCE OF TRUTH) */
 if (msg.massage === "SYNC") {
  isStoppedRef.current = msg.isStopped;

  if (msg.isStopped) {
    setSpeed(0);
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setSignal(false);
  }

  // ❌ DO NOT TOUCH SPEED HERE

  return;
}

  /* 🔥 CONFIRMED UPDATE ONLY */
  if (msg.massage === "UPDATE_CONFIRMED") {
  if (isHoldingRef.current) return; // 🚀 IGNORE DURING HOLD

  speedRef.current = msg.value2;
  setSpeed(msg.value2);
}

  /* START */
  if (msg.massage === "START") {
    isStoppedRef.current = false;
    return;
  }

  /* STOP */
  if (msg.massage === "STOP") {
    isStoppedRef.current = true;
    setSpeed(0);

    clearInterval(intervalRef.current);
    intervalRef.current = null;

    setSignal(false);
    return;
  }
});

    return () => {
      socket.off("receive_message");
    };
  }, [username]);

  /* ---------------- SAFE EMIT ---------------- */
  const emitUpdate = (value) => {
    if (isStoppedRef.current) return; // 🔒 LOCK

    if (!socket || !socket.connected) {
      console.log("⚠️ Socket not ready");
      return;
    }

    const now = Date.now();
    if (now - lastSendRef.current < 80) return;

    lastSendRef.current = now;
	 
	  const safeValue = Math.min(value, maxSpeedRef.current); 

    socket.emit("send_message", {
      uname: username,
      machinename: "Tremblr",
      massage: "Update",
      value2: safeValue,
    });
  };

  /* ---------------- HOLD ---------------- */
const startHold = (type) => {
  if (isHoldingRef.current) return;
  isHoldingRef.current = true;

  console.log("CLICK DEBUG", {
    stopped: isStoppedRef.current,
    connected: isMobileConnectedRef.current,
  });

  // 🔒 HARD LOCK
  if (isStoppedRef.current) {
    console.log("🚫 Ignored: device is stopped");
    isHoldingRef.current = false;
    return;
  }

  if (!isMobileConnectedRef.current) {
    isHoldingRef.current = false;
    return;
  }

  setSignal(true);
  clearInterval(intervalRef.current);

  intervalRef.current = setInterval(() => {
    let next = speedRef.current;

   // if (type === "up") next = Math.min(MAX_SPEED, next + 1);
	  
	if (type === "up") next = Math.min(maxSpeedRef.current, next + 1);  
    if (type === "down") next = Math.max(0, next - 1);

    speedRef.current = next;
    setSpeed(next);
    emitUpdate(next);
  }, 80);
};

 const stopHold = () => {
  isHoldingRef.current = false; // 🔥 RELEASE LOCK
  setSignal(false);
  clearInterval(intervalRef.current);
};

  /* ---------------- START / STOP ---------------- */
  const toggleStart = () => {
	  
	  if (!isMobileConnectedRef.current) {
  console.log("🚫 Mobile not connected");
  return;
}
	  
    if (!socket || !socket.connected) return;

    if (isStoppedRef.current) {
      isStoppedRef.current = false;
      setSpeed(1);

      socket.emit("send_message", {
        uname: username,
        machinename: "Tremblr",
        massage: "START",
      });
    } else {
      isStoppedRef.current = true;
      setSpeed(0);

      socket.emit("send_message", {
        uname: username,
        machinename: "Tremblr",
        massage: "STOP",
      });
    }
  };

  /* ---------------- SLIDER ---------------- */
 const updateSpeed = (v) => {
  if (isStoppedRef.current) return;

  //const val = Math.max(0, Math.min(MAX_SPEED, v));
const val = Math.max(0, Math.min(maxSpeedRef.current, v));
	 
  setSpeed(val);

  clearTimeout(debounceRef.current);
  debounceRef.current = setTimeout(() => {
    emitUpdate(val);
  }, 100);
};

  /* ---------------- UI (UNCHANGED) ---------------- */
  return (
    <div className="container">
	  
	  {!isMobileConnected && (
      <div className="lock-screen">
        <h2>🔒 Waiting for Mobile</h2>
        <p>Open Remote Play on your phone</p>
      </div>
    )}
	  
	   {/* ✅ REAL UI */}
    {isMobileConnected && (
      <>
      <h3>Speed: {speed}</h3>

      <input
  type="range"
  min="0"
   max={maxSpeed}
  value={speed}

  onMouseDown={() => (isUserInteractingRef.current = true)}
  onTouchStart={() => (isUserInteractingRef.current = true)}

  onChange={(e) => {
    if (isStoppedRef.current) return;
    setSpeed(Number(e.target.value));
  }}

  onMouseUp={(e) => {
    isUserInteractingRef.current = false;
    updateSpeed(Number(e.target.value));
  }}

  onTouchEnd={(e) => {
    isUserInteractingRef.current = false;
    updateSpeed(Number(e.target.value));
  }}

  disabled={isStoppedRef.current}
/>
<div style={{
  marginTop: "10px",
  fontSize: "18px",
  color: "#ccc",
  textAlign: "center"
}}>
  Speed Limit : <span style={{ color: "#000" }}>
    {speedLimitPercent}%</span>
 
</div>
      <div className="remote">
        <img src="/images/giglo_remote_body.png" className="remote-img" />

        <img
          src={signal ? imgOn : imgOff}
          className="signal"
        />

        {/* UP */}
        <img
          src={
            pressed.up
              ? "/images/giglo_remote_up_button_not_pressed.png"
              : "/images/giglo_remote_up_button_not_pressed.png"
          }
          className={"btn up " + (pressed.up ? "glow" : "")}
          onMouseDown={() => {
			
            setPressed((p) => ({ ...p, up: true }));
            startHold("up");
          }}
          onMouseUp={() => {
			  
            setPressed((p) => ({ ...p, up: false }));
            stopHold();
          }}
          onMouseLeave={() => {
			 
            setPressed((p) => ({ ...p, up: false }));
            stopHold();
          }}
          onTouchStart={() => {
			 
            setPressed((p) => ({ ...p, up: true }));
            startHold("up");
          }}
          onTouchEnd={() => {
			
            setPressed((p) => ({ ...p, up: false }));
            stopHold();
          }}
        />

        {/* STOP */}
        <img
          src={
            pressed.stop
              ? "/images/giglo_remote_stop_button_not_pressed.png"
              : "/images/giglo_remote_stop_button_not_pressed.png"
          }
          className={"btn stop " + (pressed.stop ? "glow" : "")}
          onClick={toggleStart}
          onMouseDown={() =>
            setPressed((p) => ({ ...p, stop: true }))
          }
          onMouseUp={() =>
            setPressed((p) => ({ ...p, stop: false }))
          }
          onMouseLeave={() =>
            setPressed((p) => ({ ...p, stop: false }))
          }
        />

        {/* DOWN */}
        <img
          src={
            pressed.down
              ? "/images/giglo_remote_down_button_not_pressed.png"
              : "/images/giglo_remote_down_button_not_pressed.png"
          }
          className={"btn down " + (pressed.down ? "glow" : "")}
          onMouseDown={() => {
			  
            setPressed((p) => ({ ...p, down: true }));
            startHold("down");
          }}
          onMouseUp={() => {
			 
            setPressed((p) => ({ ...p, down: false }));
            stopHold();
          }}
          onMouseLeave={() => {
			  
            setPressed((p) => ({ ...p, down: false }));
            stopHold();
          }}
          onTouchStart={() => {
			  
            setPressed((p) => ({ ...p, down: true }));
            startHold("down");
          }}
          onTouchEnd={() => {
			  
            setPressed((p) => ({ ...p, down: false }));
            stopHold();
          }}
        />

        {/* SOLENOID DOWN (S) */}
<img
  src="/images/alpha_remote_minus_button_not_pressed.png"
  className="btn minus"

  onMouseDown={() => {
    if (isStoppedRef.current) return;

    socket.emit("send_message", {
      uname: username,
      machinename: "Tremblr",
      massage: "SOLENOID_DOWN_ON",   // 🔥 NEW
    });
  }}

  onMouseUp={() => {
	  if (isStoppedRef.current) return;
    socket.emit("send_message", {
      uname: username,
      machinename: "Tremblr",
      massage: "SOLENOID_DOWN_OFF",  // 🔥 NEW
    });
  }}

  onMouseLeave={() => {
	  if (isStoppedRef.current) return;
    socket.emit("send_message", {
      uname: username,
      machinename: "Tremblr",
      massage: "SOLENOID_DOWN_OFF",
    });
  }}
/>

{/* SOLENOID UP (A) */}
<img
  src="/images/alpha_remote_plus_button_not_pressed.png"
  className="btn plus"

  onMouseDown={() => {
    if (isStoppedRef.current) return;

    socket.emit("send_message", {
      uname: username,
      machinename: "Tremblr",
      massage: "SOLENOID_UP_ON",   // 🔥 NEW
    });
  }}

  onMouseUp={() => {
	  if (isStoppedRef.current) return;
    socket.emit("send_message", {
      uname: username,
      machinename: "Tremblr",
      massage: "SOLENOID_UP_OFF",  // 🔥 NEW
    });
  }}

  onMouseLeave={() => {
	  if (isStoppedRef.current) return;
    socket.emit("send_message", {
      uname: username,
      machinename: "Tremblr",
      massage: "SOLENOID_UP_OFF",
    });
  }}
/>
      </div>
 </>
    )}
    </div>
  );
}